import React from 'react'

function Settings ({ className, fill }) {
  return (
    <svg fill={fill} className={className} viewBox='0 0 23.993 24'>
      <g transform='translate(-0.168)'>
        <path d='M13.7,24H10.627l-1.1-3.28-1.65-.682L4.77,21.58,2.6,19.4,4.136,16.3l-.682-1.65L.168,13.534V10.459l3.28-1.1L4.129,7.7,2.6,4.6,4.77,2.427l3.1,1.541,1.65-.682L10.634,0h3.075l1.1,3.28,1.65.682,3.1-1.541L21.741,4.6,20.2,7.7l.682,1.65,3.28,1.1v3.075l-3.28,1.1-.682,1.65,1.541,3.1-2.175,2.175-3.1-1.534-1.65.682Zm-2.291-1.091h1.507L13.934,19.9l2.57-1.064,2.843,1.411,1.064-1.064L19,16.343l1.064-2.571,3.007-1.016V11.25l-3.007-1.016L19,7.664,20.418,4.82l-1.07-1.07L16.5,5.161,13.934,4.1,12.925,1.091H11.418L10.4,4.1,7.832,5.161,4.988,3.75,3.918,4.82,5.329,7.664l-1.064,2.57L1.259,11.243V12.75l3.007,1.016,1.064,2.57L3.918,19.18l1.07,1.07,2.843-1.411L10.4,19.9Zm0,0' />
        <path d='M163.986,167.636a3.818,3.818,0,1,1,3.818-3.818A3.82,3.82,0,0,1,163.986,167.636Zm0-6.545a2.727,2.727,0,1,0,2.727,2.727A2.727,2.727,0,0,0,163.986,161.091Zm0,0' transform='translate(-151.818 -151.818)' />
      </g>
    </svg>
  )
}

Settings.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Settings
